import React, { FC } from "react";

import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import Skeleton from "@mui/material/Skeleton";

import { styles } from "./styles";

export const BODY_LINE_WIDTHS: string[] = ["60%", "80%", "45%", "70%"];

interface MobileCardSkeletonProps {
  rowCount?: number;
  withActions?: boolean;
}

const MobileCardSkeleton: FC<MobileCardSkeletonProps> = ({
  rowCount = 5,
  withActions,
}) => (
  <>
    {Array.from({ length: rowCount }).map((_, index) => (
      <ListItem key={`card-skeleton-${index}`}>
        <Box sx={styles.cardColumn}>
          <Box sx={styles.cardHeader}>
            <Skeleton animation="wave" sx={{ width: "40%", height: 24 }} />
            {withActions && (
              <Skeleton
                animation="wave"
                variant="circular"
                sx={{ width: 24, height: 24 }}
              />
            )}
          </Box>
          <Box sx={{ mt: 1.5 }}>
            {BODY_LINE_WIDTHS.map((width, lineIndex) => (
              <Skeleton
                key={`body-${index}-${lineIndex}`}
                animation="wave"
                sx={{ width, mb: 0.5 }}
              />
            ))}
          </Box>
        </Box>
      </ListItem>
    ))}
  </>
);

export default MobileCardSkeleton;
